"use client";

import { SessionProvider } from "next-auth/react";
import type { ReactNode } from "react";

/**
 * Onda 19.21 v2: ThemeProvider removido — app é DARK ONLY.
 * A classe "dark" é hardcoded em <html> em layout.tsx.
 */
export function Providers({ children }: { children: ReactNode }) {
  return <SessionProvider>{children}</SessionProvider>;
}
